<template>
  <div class="mnp-in-data container">
    <span class="text-sm text-muted required-field-hint">*Pflichtfeld</span>
    <div class="data-head-box container-box">
      <div class="content-limiter">
        <slot name="txtBefore"></slot>
        <slot v-if="portationTime_ === 'CONTRACT_END'" name="txtContractEnd"></slot>
        <slot v-if="portationTime_ === 'AS_SOON_AS_POSSIBLE'" name="txtASAP"></slot>
        <slot name="txtBeforeLabel"></slot>
        <DataInput
          ref="data"
          :portation-msisdn.sync="portationMsisdn"
          :person.sync="person"
          :selected-keys.sync="selectedKeys"
          :invalid.sync="dataInvalid"
        >
          <template v-for="slot in possibleChildSlotsFor('DataInput')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </DataInput>
      </div>
    </div>
    <div class="payment-information container-box">
      <div class="content-limiter">
        <slot name="txtBeforePaymentInformation"></slot>
        <PaymentData
          v-if="paymentInformation"
          :is-no-payment="isNoPayment"
          :is-credit-card="isCreditCard"
          :is-bank-account="isBankAccount"
          :payment-information="paymentInformation"
        >
          <template v-for="slot in possibleChildSlotsFor('ViewWrapper')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </PaymentData>
        <!-- <slot name="txtAfterPaymentInformation"></slot> -->
      </div>
    </div>
    <div class="flex-justify-content-between">
      <button class="button button--secondary" @click="back()">Zurück</button>
      <button class="button button--primary" @click="next()" :disabled="loading">Weiter</button>
    </div>
  </div>
</template>

<script>
import DataInput from './DataInput.vue'
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import processSteps from '@/mixins/processSteps'
import { stepName as previousProcessStep } from './Start.vue'
import { stepName as nextProcessStep } from './Summary.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapActions, mapMutations } from 'vuex'
import { sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import PaymentData from './PaymentData.vue'
export const stepName = 'mnpInData'
export default {
  name: 'MnpInData',
  data() {
    return {
      loading: false,
      dataInvalid: true,
      portationMsisdn: '',
      selectedKeys: 'default',
      paymentInformation: {
        paymentType: {}
      },
      person: {
        gender: 'FEMALE',
        firstName: '',
        lastName: '',
        birthDate: null
      }
    }
  },
  props: {},
  computed: {
    isNoPayment() {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    }
  },
  methods: {
    ...mapMutations('mnpIn', ['goToStep']),
    ...mapActions('mnpIn', ['storePersonData']),
    back() {
      this.goToStep(this.previousStep)
    },
    next() {
      if (this.loading) return
      this.$refs.data.$v.$touch()

      if (this.$v.dataInvalid.$invalid) {
        this.$nextTick(() => {
          const firstError = document.querySelector('.input--invalid')
          if (firstError) firstError.focus()

          this.loading = false
        })
      } else {
        this.loading = true
        this.storePersonData({
          person: this.person,
          portationMsisdn: this.portationMsisdn,
          selectedKeys: this.selectedKeys,
          nextStep: this.nextStep
        }).then(
          () => {
            this.loading = false
          },
          () => {
            this.loading = false
          }
        )
      }
    }
  },
  components: {
    DataInput,
    PaymentData
  },
  mixins: [
    validationMixin,
    slotProxy(),
    processSteps(stepName, previousProcessStep, nextProcessStep),
    syncProperty('portationTime', 'portationTime_')
  ],
  apollo: {
    paymentInformation: function() {
      return wrapQuery(
        gql`
          query changePayment {
            paymentInformation {
              paymentType {
                ... on BankAccount {
                  type
                  iban
                  owner
                }
                ... on CreditCard {
                  type
                  holder
                  company
                  expiryMonth
                  expiryYear
                  lastDigits
                }
              }
            }
          }
        `,
        this,
        'paymentInformation'
      )
    }
  },
  validations() {
    return {
      dataInvalid: {
        sameAs: sameAs(() => false)
      }
    }
  }
}
</script>
